// import React, { useRef, useState } from 'react'
// import { Link } from 'react-router-dom';
// import './footer.scss'
// import FooterVideo from '../../Assets/Footer.mp4'
// import { FiChevronRight, FiSend, FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi'
// import { AiFillInstagram, AiFillYoutube, AiOutlineTwitter, AiFillFacebook } from 'react-icons/ai'
// import { FaTripadvisor, FaWhatsapp } from 'react-icons/fa'
// import { BiWorld } from 'react-icons/bi'
// import emailjs from '@emailjs/browser'
// import Logo from '../../Assets/Logo.png'

// const Footer = () => {
//     const form = useRef();
//     const [email, setEmail] = useState('');
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isSubscribed, setIsSubscribed] = useState(false);

//     const sendEmail = (e) => {
//         e.preventDefault();
//         setIsSubmitting(true);

//         emailjs.sendForm(
//             "service_a0f6obr",
//             "template_0hv31k9",
//             form.current,
//             "pLd3QhrFmeSifW3Ka"
//         )
//             .then(() => {
//                 setIsSubscribed(true);
//                 setEmail('');
//                 setTimeout(() => setIsSubscribed(false), 3000);
//             })
//             .catch((error) => {
//                 console.error('Email send error:', error);
//                 alert("Error sending email. Please try again.");
//             })
//             .finally(() => {
//                 setIsSubmitting(false);
//             });
//     };

//     const quickLinks = [
//         { title: 'Home', path: '/' },
//         { title: 'About Us', path: '/About' },
//         { title: 'Challenging Treks', path: '/category/Challenging-treks' },
//         { title: 'Cultural Tours', path: '/category/Cultural-tours' },
//         { title: 'Expeditions', path: '/category/8000M Plus Peaks-expeditions' },
//         { title: 'Contact', path: '/Contact' },
//     ];

//     const popularTours = [
//         { title: 'Mohenjo Daro Tours', path: '/mohenjo-daro-tours' },
//         { title: 'Lahore Heritage Tours', path: '/lahore-heritage-tours' },
//         { title: 'Hunza Valley Tours', path: '/hunza-valley-tours' },
//         { title: 'Multan City Tours', path: '/multan-city-tours' },
//         { title: 'Skardu Valley Tours', path: '/skardu-valley-tours' },
//         { title: 'Ghanche Valley Tours', path: '/ghanche-valley-tours' },
//     ];

//     const expeditions = [
//         { title: 'K2 Expedition', path: '/k2-expedition' },
//         { title: 'Nanga Parbat Expedition', path: '/nangaparbat-expedition' },
//         { title: 'Broad Peak Expedition', path: '/broad-peak-expedition' },
//         { title: 'Gasherbrum II Expedition', path: '/gasherbrum-ii-expedition' },
//         { title: 'Gasherbrum I Expedition', path: '/gasherbrum-i-expedition' },
//         { title: 'Laila Peak Expedition', path: '/laila-peak-expedition' },
//         { title: 'Trango Tower Expedition', path: '/trango-tower-expedition' },
//     ];

//     const treks = [
//         { title: 'K2 Base Camp Trek', path: '/k2-base-camp-trek' },
//         { title: 'K2 Gandogoro La Trek', path: '/k2-gandogoro-la-trek' },
//         { title: 'Biafo Hispar Trek', path: '/biafo-hispar-trek' },
//         { title: 'Fairy Meadows Trek', path: '/fairy-meadows-trek' },
//         { title: 'Rush Lake Trek', path: '/rush-lake-trek' },
//         { title: 'Rakaposhi Base Camp', path: '/rakaposhi-trek' },
//     ];

//     const contactInfo = [
//         { icon: <FiMapPin />, text: 'Skardu, Pakistan' },
//         { icon: <FiPhone />, text: '+92 349 158 9717' },
//         { icon: <FiMail />, text: 'info@worldadventurestours.com' },
//         { icon: <FiClock />, text: 'Mon - Fri: 9:00 AM - 6:00 PM' },
//     ];

//     const socialLinks = [
//         { icon: <AiFillFacebook />, url: 'https://www.facebook.com/WorldAdventurTours', label: 'Facebook' },
//         { icon: <AiFillInstagram />, url: 'https://www.instagram.com/worldadventurestours/?hl=en', label: 'Instagram' },
//         { icon: <AiOutlineTwitter />, url: 'https://x.com/Mr_awaisqarni', label: 'Twitter' },
//         { icon: <FaTripadvisor />, url: 'https://tripadvisor.com/worldadventurestours', label: 'TripAdvisor' },
//         { icon: <FaWhatsapp />, url: 'https://wa.me/971555936448', label: 'WhatsApp' },
//     ];

//     return (
//         <footer className="footer">
//             {/* Newsletter Section */}
//             <div className="newsletter-section">
//                 <div className="newsletter-container container">
//                     <div className="newsletter-content">
//                         <div className="newsletter-text">
//                             <span className="newsletter-badge">Stay Updated</span>
//                             <h2>Subscribe to Our Newsletter</h2>
//                             <p>Get exclusive deals, travel tips, and adventure updates directly to your inbox</p>
//                         </div>
                        
//                         <form ref={form} onSubmit={sendEmail} className="newsletter-form">
//                             <div className="input-group">
//                                 <input 
//                                     type="email" 
//                                     name="user_email"
//                                     value={email}
//                                     onChange={(e) => setEmail(e.target.value)}
//                                     placeholder="Enter your email address"
//                                     required
//                                     disabled={isSubmitting}
//                                 />
//                                 <button 
//                                     type="submit" 
//                                     className="subscribe-btn"
//                                     disabled={isSubmitting || isSubscribed}
//                                 >
//                                     {isSubmitting ? (
//                                         <span className="spinner"></span>
//                                     ) : isSubscribed ? (
//                                         'Subscribed!'
//                                     ) : (
//                                         <>
//                                             Subscribe <FiSend className="icon" />
//                                         </>
//                                     )}
//                                 </button>
//                             </div>
//                             <p className="newsletter-note">We respect your privacy. Unsubscribe at any time.</p>
//                         </form>
//                     </div>
//                 </div>
//             </div>

//             {/* Main Footer Content */}
//             <div className="footer-main">
//                 <div className="footer-container container">
//                     {/* Brand Column */}
//                     <div className="footer-column brand-column">
//                         <Link to="/" className="footer-brand">
//                             <img src={Logo} alt="World Adventures Tours" className="brand-logo" />
//                             <div className="brand-text">
//                                 <h3>World Adventures Tours</h3>
//                                 <p className="brand-tagline">Explore Beyond Boundaries</p>
//                             </div>
//                         </Link>
                        
//                         <p className="company-description">
//                             As Pakistan's premier adventure travel company, we specialize in creating unforgettable 
//                             experiences across majestic mountains, ancient civilizations, and breathtaking landscapes.
//                         </p>
                        
//                         <div className="contact-details">
//                             {contactInfo.map((item, index) => (
//                                 <div key={index} className="contact-item">
//                                     {item.icon}
//                                     <span>{item.text}</span>
//                                 </div>
//                             ))}
//                         </div>

//                         <div className="social-links">
//                             <span className="social-title">Follow Our Adventures</span>
//                             <div className="social-icons">
//                                 {socialLinks.map((social, index) => (
//                                     <a 
//                                         key={index}
//                                         href={social.url}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         className="social-icon"
//                                         aria-label={social.label}
//                                     >
//                                         {social.icon}
//                                     </a>
//                                 ))}
//                             </div>
//                         </div>
//                     </div>

//                     {/* Quick Links Column */}
//                     <div className="footer-column">
//                         <h4 className="column-title">Quick Links</h4>
//                         <ul className="footer-links">
//                             {quickLinks.map((link, index) => (
//                                 <li key={index}>
//                                     <Link to={link.path} className="footer-link">
//                                         <FiChevronRight className="link-icon" />
//                                         {link.title}
//                                     </Link>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>

//                     {/* Popular Tours Column */}
//                     <div className="footer-column">
//                         <h4 className="column-title">Popular Tours</h4>
//                         <ul className="footer-links">
//                             {popularTours.map((tour, index) => (
//                                 <li key={index}>
//                                     <Link to={tour.path} className="footer-link">
//                                         <FiChevronRight className="link-icon" />
//                                         {tour.title}
//                                     </Link>
//                                 </li>
//                             ))}
//                         </ul>
//                     </div>

//                     {/* Adventure Columns */}
//                     <div className="footer-column-group">
//                         <div className="footer-column">
//                             <h4 className="column-title">Expeditions</h4>
//                             <ul className="footer-links">
//                                 {expeditions.map((expedition, index) => (
//                                     <li key={index}>
//                                         <Link to={expedition.path} className="footer-link">
//                                             <FiChevronRight className="link-icon" />
//                                             {expedition.title}
//                                         </Link>
//                                     </li>
//                                 ))}
//                             </ul>
//                         </div>

//                         <div className="footer-column">
//                             <h4 className="column-title">Treks</h4>
//                             <ul className="footer-links">
//                                 {treks.map((trek, index) => (
//                                     <li key={index}>
//                                         <Link to={trek.path} className="footer-link">
//                                             <FiChevronRight className="link-icon" />
//                                             {trek.title}
//                                         </Link>
//                                     </li>
//                                 ))}
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Footer Bottom */}
//             <div className="footer-bottom">
//                 <div className="bottom-container container">
//                     <div className="copyright">
//                         <p>
//                             © {new Date().getFullYear()} World Adventures Tours. All Rights Reserved.
//                             <span className="separator">|</span>
//                             <Link to="/privacy-policy" className="policy-link">Privacy Policy</Link>
//                             <span className="separator">|</span>
//                             <Link to="/terms-conditions" className="policy-link">Terms & Conditions</Link>
//                         </p>
//                     </div>
                    
//                     <div className="certifications">
//                         <div className="certification-item">
//                             <BiWorld className="cert-icon" />
//                             <span>Licensed Tour Operator</span>
//                         </div>
//                         <div className="certification-item">
//                             <FaWhatsapp className="cert-icon" />
//                             <span>24/7 Support Available</span>
//                         </div>
//                     </div>
                    
//                     <div className="payment-methods">
//                         <span className="payment-text">Secure Payments:</span>
//                         <div className="payment-icons">
//                             <span className="payment-icon visa">Visa</span>
//                             <span className="payment-icon mastercard">MasterCard</span>
//                             <span className="payment-icon paypal">PayPal</span>
//                             <span className="payment-icon stripe">Stripe</span>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </footer>
//     )
// }

// export default Footer

import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import './footer.scss'
import FooterVideo from '../../Assets/Footer.mp4'
import { FiChevronRight, FiSend, FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi'
import { AiFillInstagram, AiFillYoutube, AiOutlineTwitter, AiFillFacebook } from 'react-icons/ai'
import { FaTripadvisor, FaWhatsapp, FaShieldAlt, FaCertificate, FaRegCheckCircle } from 'react-icons/fa'
import { BiWorld } from 'react-icons/bi'
import { MdVerified, MdSecurity } from 'react-icons/md'
import { RiGovernmentLine } from 'react-icons/ri'
import emailjs from '@emailjs/browser'
import Logo from '../../Assets/Logo.png'

// Import logos (Option 2: Assets folder)
import GovernmentOfPakistanLogo from '../../Assets/Logos/GovernmentOfPakistanLogo.png'
import AlpineClubPakistan from '../../Assets/Logos/AlpineClubPakistan.png'
import BAATO from '../../Assets/Logos/BAATO.jpeg'
import PATO from '../../Assets/Logos/PATO.png'
import WAT from '../../Assets/Logos/WAT.png'

const Footer = () => {
    const form = useRef();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        emailjs.sendForm(
            "service_a0f6obr",
            "template_0hv31k9",
            form.current,
            "pLd3QhrFmeSifW3Ka"
        )
            .then(() => {
                setIsSubscribed(true);
                setEmail('');
                setTimeout(() => setIsSubscribed(false), 3000);
            })
            .catch((error) => {
                console.error('Email send error:', error);
                alert("Error sending email. Please try again.");
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const quickLinks = [
        { title: 'Home', path: '/' },
        { title: 'About Us', path: '/About' },
        { title: 'Challenging Treks', path: '/category/Challenging-treks' },
        { title: 'Cultural Tours', path: '/category/Cultural-tours' },
        { title: 'Expeditions', path: '/category/8000M Plus Peaks-expeditions' },
        { title: 'Contact', path: '/Contact' },
    ];

    const popularTours = [
        { title: 'Mohenjo Daro Tours', path: '/mohenjo-daro-tours' },
        { title: 'Lahore Heritage Tours', path: '/lahore-heritage-tours' },
        { title: 'Hunza Valley Tours', path: '/hunza-valley-tours' },
        { title: 'Multan City Tours', path: '/multan-city-tours' },
        { title: 'Skardu Valley Tours', path: '/skardu-valley-tours' },
        { title: 'Ghanche Valley Tours', path: '/ghanche-valley-tours' },
    ];

    const expeditions = [
        { title: 'K2 Expedition', path: '/k2-expedition' },
        { title: 'Nanga Parbat Expedition', path: '/nangaparbat-expedition' },
        { title: 'Broad Peak Expedition', path: '/broad-peak-expedition' },
        { title: 'Gasherbrum II Expedition', path: '/gasherbrum-ii-expedition' },
        { title: 'Gasherbrum I Expedition', path: '/gasherbrum-i-expedition' },
        { title: 'Laila Peak Expedition', path: '/laila-peak-expedition' },
        { title: 'Trango Tower Expedition', path: '/trango-tower-expedition' },
    ];

    const treks = [
        { title: 'K2 Base Camp Trek', path: '/k2-base-camp-trek' },
        { title: 'K2 Gandogoro La Trek', path: '/k2-gandogoro-la-trek' },
        { title: 'Biafo Hispar Trek', path: '/biafo-hispar-trek' },
        { title: 'Fairy Meadows Trek', path: '/fairy-meadows-trek' },
        { title: 'Rush Lake Trek', path: '/rush-lake-trek' },
        { title: 'Rakaposhi Base Camp', path: '/rakaposhi-trek' },
    ];

    const contactInfo = [
        { icon: <FiMapPin />, text: 'Skardu, Pakistan' },
        { icon: <FiPhone />, text: '+92 349 158 9717' },
        { icon: <FiMail />, text: 'info@worldadventurestours.com' },
        { icon: <FiClock />, text: 'Mon - Fri: 9:00 AM - 6:00 PM' },
    ];

    const socialLinks = [
        { icon: <AiFillFacebook />, url: 'https://www.facebook.com/WorldAdventurTours', label: 'Facebook' },
        { icon: <AiFillInstagram />, url: 'https://www.instagram.com/worldadventurestours/?hl=en', label: 'Instagram' },
        { icon: <AiOutlineTwitter />, url: 'https://x.com/Mr_awaisqarni', label: 'Twitter' },
        { icon: <FaTripadvisor />, url: 'https://tripadvisor.com/worldadventurestours', label: 'TripAdvisor' },
        { icon: <FaWhatsapp />, url: 'https://wa.me/971555936448', label: 'WhatsApp' },
    ];

    // Accreditation logos data
    const accreditationLogos = [
        { 
            id: 1,
            img: GovernmentOfPakistanLogo, 
            alt: 'Government of Pakistan - Licensed Tour Operator',
            title: 'Government of Pakistan',
            license: 'License #DTS-GB-021'
        },
        { 
            id: 2,
            img: BAATO, 
            alt: 'Member Of BAATO Association',
            title: 'BAATO Member'
        },
        { 
            id: 3,
            img: AlpineClubPakistan, 
            alt: 'Member Of Alpine Club Pakistan',
            title: 'Alpine Club Paksitan'
        },
        { 
            id: 4,
            img: PATO, 
            alt: 'Member Of PATO Association',
            title: 'PATO Association'
        },
        { 
            id: 5,
            img: WAT, 
            alt: 'TOURS Operator',
            title: 'world adventures tours'
        },
    ];

    return (
        <footer className="footer">
            {/* Newsletter Section */}
            <div className="newsletter-section">
                <div className="newsletter-container container">
                    <div className="newsletter-content">
                        <div className="newsletter-text">
                            <span className="newsletter-badge">Stay Updated</span>
                            <h2>Subscribe to Our Newsletter</h2>
                            <p>Get exclusive deals, travel tips, and adventure updates directly to your inbox</p>
                        </div>
                        
                        <form ref={form} onSubmit={sendEmail} className="newsletter-form">
                            <div className="input-group">
                                <input 
                                    type="email" 
                                    name="user_email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email address"
                                    required
                                    disabled={isSubmitting}
                                />
                                <button 
                                    type="submit" 
                                    className="subscribe-btn"
                                    disabled={isSubmitting || isSubscribed}
                                >
                                    {isSubmitting ? (
                                        <span className="spinner"></span>
                                    ) : isSubscribed ? (
                                        'Subscribed!'
                                    ) : (
                                        <>
                                            Subscribe <FiSend className="icon" />
                                        </>
                                    )}
                                </button>
                            </div>
                            <p className="newsletter-note">We respect your privacy. Unsubscribe at any time.</p>
                        </form>
                    </div>
                </div>
            </div>

            {/* Accreditation Logos Bar - NEW SECTION */}
            <div className="accreditation-bar">
                <div className="container">
                    <div className="accreditation-content">
                        <div className="accreditation-title">
                            <RiGovernmentLine className="title-icon" />
                            <span>Registered & Accredited By</span>
                        </div>
                        <div className="accreditation-logos">
                            {accreditationLogos.map((logo) => (
                                <div key={logo.id} className="accreditation-logo-item" title={logo.alt}>
                                    <img src={logo.img} alt={logo.alt} loading="lazy" />
                                    {logo.license && <span className="license-badge">{logo.license}</span>}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Footer Content */}
            <div className="footer-main">
                <div className="footer-container container">
                    {/* Brand Column */}
                    <div className="footer-column brand-column">
                        <Link to="/" className="footer-brand">
                            <img src={Logo} alt="World Adventures Tours" className="brand-logo" />
                            <div className="brand-text">
                                <h3>World Adventures Tours</h3>
                                <p className="brand-tagline">Explore Beyond Boundaries</p>
                            </div>
                        </Link>
                        
                        <p className="company-description">
                            As Pakistan's premier adventure travel company, we specialize in creating unforgettable 
                            experiences across majestic mountains, ancient civilizations, and breathtaking landscapes.
                        </p>
                        
                        {/* Trust Badges - NEW */}
                        <div className="trust-badges">
                            <div className="trust-badge">
                                <FaShieldAlt className="badge-icon" />
                                <div className="badge-text">
                                    <strong>Secure Payments</strong>
                                    <span>Stripe Protected</span>
                                </div>
                            </div>
                            <div className="trust-badge">
                                <MdVerified className="badge-icon" />
                                <div className="badge-text">
                                    <strong>Verified Company</strong>
                                    <span>License #1754</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="contact-details">
                            {contactInfo.map((item, index) => (
                                <div key={index} className="contact-item">
                                    {item.icon}
                                    <span>{item.text}</span>
                                </div>
                            ))}
                        </div>

                        <div className="social-links">
                            <span className="social-title">Follow Our Adventures</span>
                            <div className="social-icons">
                                {socialLinks.map((social, index) => (
                                    <a 
                                        key={index}
                                        href={social.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="social-icon"
                                        aria-label={social.label}
                                    >
                                        {social.icon}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Quick Links Column */}
                    <div className="footer-column">
                        <h4 className="column-title">Quick Links</h4>
                        <ul className="footer-links">
                            {quickLinks.map((link, index) => (
                                <li key={index}>
                                    <Link to={link.path} className="footer-link">
                                        <FiChevronRight className="link-icon" />
                                        {link.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Popular Tours Column */}
                    <div className="footer-column">
                        <h4 className="column-title">Popular Tours</h4>
                        <ul className="footer-links">
                            {popularTours.map((tour, index) => (
                                <li key={index}>
                                    <Link to={tour.path} className="footer-link">
                                        <FiChevronRight className="link-icon" />
                                        {tour.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Adventure Columns */}
                    <div className="footer-column-group">
                        <div className="footer-column">
                            <h4 className="column-title">Expeditions</h4>
                            <ul className="footer-links">
                                {expeditions.map((expedition, index) => (
                                    <li key={index}>
                                        <Link to={expedition.path} className="footer-link">
                                            <FiChevronRight className="link-icon" />
                                            {expedition.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="footer-column">
                            <h4 className="column-title">Treks</h4>
                            <ul className="footer-links">
                                {treks.map((trek, index) => (
                                    <li key={index}>
                                        <Link to={trek.path} className="footer-link">
                                            <FiChevronRight className="link-icon" />
                                            {trek.title}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <div className="bottom-container container">
                    <div className="copyright">
                        <p>
                            © {new Date().getFullYear()} World Adventures Tours. All Rights Reserved.
                            <span className="separator">|</span>
                            <Link to="/terms-and-conditions" className="policy-link">Privacy Policy</Link>
                            <span className="separator">|</span>
                            <Link to="/terms-and-conditions" className="policy-link">Terms & Conditions</Link>
                        </p>
                    </div>
                    
                    <div className="certifications">
                        <div className="certification-item">
                            <BiWorld className="cert-icon" />
                            <span>Licensed Tour Operator</span>
                        </div>
                        <div className="certification-item">
                            <FaWhatsapp className="cert-icon" />
                            <span>24/7 Support Available</span>
                        </div>
                    </div>
                    
                    <div className="payment-methods">
                        <span className="payment-text">Secure Payments:</span>
                        <div className="payment-icons">
                            <span className="payment-icon visa">Visa</span>
                            <span className="payment-icon mastercard">MasterCard</span>
                            <span className="payment-icon paypal">PayPal</span>
                            <span className="payment-icon stripe">Stripe</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer